export default __webpack_public_path__ + "static/media/i-phone-x-clay-white-perspective-mockup-copy@2x.c5d7bd4b.png";